import { render } from "./TipSplits.vue?vue&type=template&id=9616163e"
import script from "./TipSplits.vue?vue&type=script&lang=js"
export * from "./TipSplits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__